import React, {useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchSettingsJSON, setFullLockout} from "apps/DRAW_PREDICTOR/modules/actions";
import {getDrawPredictorSettings, isFullLockout} from "apps/DRAW_PREDICTOR/modules/selectors";
import {getPadForTimer, LANGUAGE_PATH, useTimer} from "modules";
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const Label = styled.p`
	font-family: "Qatar2022", sans-serif;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 140%;
	color: #fff;
`;

const Time = styled.p`
	font-family: "Qatar2022", sans-serif;
	font-style: normal;
	font-weight: normal;
	font-size: 20px;
	line-height: 140%;
	color: #fff;
`;

export const LockoutTimer: React.FC = () => {
	const dispatch = useDispatch();
	const settings = useSelector(getDrawPredictorSettings);
	const countdown = useTimer(settings.lockoutDate);
	const locked = settings.isLocked || countdown.isComplete;
	const isLocked = useSelector(isFullLockout);
	const {t} = useTranslation(LANGUAGE_PATH);

	useEffect(() => {
		dispatch(fetchSettingsJSON());
	}, [dispatch]);

	useEffect(() => {
		if (countdown.isComplete && !isLocked) {
			dispatch(setFullLockout());
		}
	}, [countdown.isComplete, isLocked, dispatch]);

	const getFormattedTime = useCallback(() => {
		const {days, hours, minutes, seconds} = countdown;
		if (days > 0) {
			return `${getPadForTimer(days)}D:${getPadForTimer(hours)}H:${getPadForTimer(minutes)}M`;
		}
		return `${getPadForTimer(hours)}H:${getPadForTimer(minutes)}M:${getPadForTimer(seconds)}S`;
	}, [countdown]);

	const time = locked ? t("draw.countdown.locked") : getFormattedTime();

	return (
		<div>
			<Label>{t("draw.countdown.copy")}</Label>
			<Time>{time}</Time>
		</div>
	);
};
